import { DocumentType } from "domain/entities/document-type";
import { DocumentTypeInputFilter } from "domain/models/document-type-input-filter";
import { useDocumentTypeByFilter } from "presentation/hooks/use-query-document-type";
import { useDocumentTypeStore } from "presentation/stores/use-document_type-store";
import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";

const DocumentTypeDropdown: React.FC<{
  options: ColumnFilterElementTemplateOptions;
}> = ({ options }) => {
  const [documentTypeOptions, setDocumentTypeOptions] = useState<
    { label: string; value: string }[]
  >([]);

  const { documentType, setDocumentType } = useDocumentTypeStore();

  const { data: documentTypesData } = useDocumentTypeByFilter({
    limit: 100,
    justCPStypes: true,
  } as DocumentTypeInputFilter);

  useEffect(() => {
    setDocumentType(documentTypesData?.data);
  }, [documentTypesData]);

  useEffect(() => {
    setDocumentTypeOptions(
      documentType.map((item: DocumentType) => ({
        label: item.name,
        value: item.name,
      }))
    );
  }, [documentType]);

  return (
    <Dropdown
      value={options.value}
      options={documentTypeOptions}
      onChange={(e) => options.filterCallback(e.value)}
      placeholder="Selecione o tipo de documento"
      showClear
    />
  );
};
export default DocumentTypeDropdown;
